import { CTA } from '@volkswagen-onehub/components-core';
import React from 'react';
import { useOneFormContext } from 'src/feature-app';
import { useTrackingManager } from 'src/feature-app/hooks/use-tracking-manager';

export const NextStepCTA = () => {
	const { nextStep } = useOneFormContext();
	const trackingManager = useTrackingManager();

	return (
		<div style={{ paddingTop: '44px' }}>
			<CTA
				tag="button"
				emphasis="primary"
				onClick={e => {
					trackingManager.trackFormStepButtonClick({
						contentId: 'Siguiente',
					});
					e.preventDefault();
					nextStep();
				}}
				aria-label="Empezar"
			>
				Empezar
			</CTA>
		</div>
	);
};
